"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uiPropTypes = require("@instructure/ui-prop-types");

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _deprecated = require("@instructure/ui-utils/lib/react/deprecated");

var _getElementType = _interopRequireDefault(require("@instructure/ui-utils/lib/react/getElementType"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'fcKBR',
  template: function template(theme) {
    return "\n\n.fcKBR_bGBk{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:".concat(theme.fontFamily || 'inherit', ";line-height:").concat(theme.lineHeight || 'inherit', ";margin:0;text-rendering:optimizeLegibility}\n\ninput.fcKBR_bGBk[type]{-moz-appearance:none;-webkit-appearance:none;appearance:none;background:none;border:none;border-radius:0;box-shadow:none;box-sizing:border-box;color:inherit;display:block;height:auto;line-height:inherit;margin:-6px 0 0 0;outline:0;padding:0;text-align:start;width:100%}\n\n[dir=ltr] input.fcKBR_bGBk[type]{text-align:left}\n\n[dir=rtl] input.fcKBR_bGBk[type]{text-align:right}\n\ninput.fcKBR_bGBk[type]:focus{outline:none}\n\n.fcKBR_fIqS{font-size:").concat(theme.h1FontSize || 'inherit', ";font-weight:").concat(theme.h1FontWeight || 'inherit', "}\n\n.fcKBR_eABG{font-size:").concat(theme.h2FontSize || 'inherit', ";font-weight:").concat(theme.h2FontWeight || 'inherit', "}\n\n.fcKBR_dlZd{font-size:").concat(theme.h3FontSize || 'inherit', ";font-weight:").concat(theme.h3FontWeight || 'inherit', "}\n\n.fcKBR_bAmB{font-size:").concat(theme.h4FontSize || 'inherit', ";font-weight:").concat(theme.h4FontWeight || 'inherit', "}\n\n.fcKBR_eRZv{font-size:").concat(theme.h5FontSize || 'inherit', ";font-weight:").concat(theme.h5FontWeight || 'inherit', "}\n\n.fcKBR_dTMd{border-top:").concat(theme.borderWidth || 'inherit', " ").concat(theme.borderStyle || 'inherit', " ").concat(theme.borderColor || 'inherit', ";padding-top:").concat(theme.borderPadding || 'inherit', "}\n\n.fcKBR_evMo{border-bottom:").concat(theme.borderWidth || 'inherit', " ").concat(theme.borderStyle || 'inherit', " ").concat(theme.borderColor || 'inherit', ";padding-bottom:").concat(theme.borderPadding || 'inherit', "}\n\n.fcKBR_fAVi{color:inherit}\n\n.fcKBR_qFsi{color:").concat(theme.primaryColor || 'inherit', "}\n\n.fcKBR_bLsb{color:").concat(theme.secondaryColor || 'inherit', "}\n\n.fcKBR_ezBQ{color:").concat(theme.primaryInverseColor || 'inherit', "}\n\n.fcKBR_dlnd{color:").concat(theme.secondaryInverseColor || 'inherit', "}\n\n.fcKBR_cJLh{color:").concat(theme.successColor || 'inherit', "}\n\n.fcKBR_eHcp{color:").concat(theme.warningColor || 'inherit', "}\n\n.fcKBR_fpfC{color:").concat(theme.brandColor || 'inherit', "}\n\n.fcKBR_dwua{color:").concat(theme.errorColor || 'inherit', "}\n\n.fcKBR_ZpoW{font-size:inherit;font-weight:inherit;line-height:inherit;margin:0}\n\n.fcKBR_bOQC{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}");
  },
  'root': 'fcKBR_bGBk',
  'h1': 'fcKBR_fIqS',
  'h2': 'fcKBR_eABG',
  'h3': 'fcKBR_dlZd',
  'h4': 'fcKBR_bAmB',
  'h5': 'fcKBR_eRZv',
  'border-top': 'fcKBR_dTMd',
  'border-bottom': 'fcKBR_evMo',
  'color-inherit': 'fcKBR_fAVi',
  'color-primary': 'fcKBR_qFsi',
  'color-secondary': 'fcKBR_bLsb',
  'color-primary-inverse': 'fcKBR_ezBQ',
  'color-secondary-inverse': 'fcKBR_dlnd',
  'color-success': 'fcKBR_cJLh',
  'color-warning': 'fcKBR_eHcp',
  'color-brand': 'fcKBR_fpfC',
  'color-error': 'fcKBR_dwua',
  'reset': 'fcKBR_ZpoW',
  'ellipsis': 'fcKBR_bOQC'
};
var Heading = (
/**
---
category: components
---
**/
_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Heading, _Component);

  function Heading() {
    (0, _classCallCheck2.default)(this, Heading);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Heading).apply(this, arguments));
  }

  (0, _createClass2.default)(Heading, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          border = _this$props.border,
          children = _this$props.children,
          color = _this$props.color,
          level = _this$props.level,
          ellipsis = _this$props.ellipsis,
          margin = _this$props.margin,
          elementRef = _this$props.elementRef;
      var ElementType = (0, _getElementType.default)(Heading, this.props, function () {
        if (level === 'reset') {
          return 'span';
        } else {
          return level;
        }
      });

      var passthroughProps = _View.default.omitViewProps((0, _passthroughProps.omitProps)(this.props, Heading.propTypes), Heading);

      return _react.default.createElement(_View.default, Object.assign({}, passthroughProps, {
        className: (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, styles.root, true), (0, _defineProperty2.default)(_classnames, styles[level], true), (0, _defineProperty2.default)(_classnames, styles["color-".concat(color)], color), (0, _defineProperty2.default)(_classnames, styles["border-".concat(border)], border !== 'none'), (0, _defineProperty2.default)(_classnames, styles.ellipsis, ellipsis), _classnames)),
        as: ElementType,
        margin: margin,
        elementRef: elementRef
      }), children);
    }
  }]);
  Heading.displayName = "Heading";
  return Heading;
}(_react.Component), _class2.propTypes = {
  border: _propTypes.default.oneOf(['none', 'top', 'bottom']),
  children: _uiPropTypes.childrenOrValue,
  color: (0, _deprecated.deprecatePropValues)(_propTypes.default.oneOf(['primary', 'secondary', 'primary-inverse', 'secondary-inverse', 'inherit']), ['success', 'warning', 'error', 'brand']),
  level: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'reset']),

  /**
  * the element type to render as (defaults to the level)
  */
  as: _propTypes.default.elementType,
  // eslint-disable-line react/require-default-props
  ellipsis: _propTypes.default.bool,

  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,
  elementRef: _propTypes.default.func
}, _class2.defaultProps = {
  children: null,
  margin: void 0,
  elementRef: void 0,
  border: 'none',
  color: 'inherit',
  level: 'h2',
  ellipsis: false
}, _temp)) || _class) || _class);
exports.default = Heading;